import {Injectable} from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpInterceptor
} from "@angular/common/http";
import {AuthService} from "../login/auth.service";
import {throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';

/*
Intercept all requests and add the token to the header
 */

//Add to app.module.ts
//{provide: HTTP_INTERCEPTORS, useClass: AuthIntercepterService, multi: true}
@Injectable()
export class AuthIntercepterService implements HttpInterceptor {

  //TODO: ADD CACHE BUSTER

  constructor(private authService: AuthService) {}

  //https://www.positronx.io/angular-error-handling-tutorial-with-examples/

  private handleError(error: HttpErrorResponse) {

    console.log('error object',error)
    console.log('INTERCEPstatus code TER ERROR: status_code',error.status)
    console.log('INTERCEPTER ERROR: error message',error.error.message)
    console.log('INTERCEPTER ERROR: error url',error.url) // http://0.0.0.0:8050/account/agency/agcydfca059b00744c838b4484268ed792f6
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error.error.message);
  };

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    console.log('AuthIntercepterService');
    const userData: {
      uid: string,
      username: string,
      email: string,
      role: string,
      refresh_token: string,
      access_token: string,
      id_token: string,
      _tokenExpirationDate: string
      exp: number
    } = JSON.parse(localStorage.getItem('userData'));


    // TEST FOR USER DATA AND THAT THE REQUEST URL DOES NOT START WITH A PRESINGED URL FROM S3
    if (userData && req.url.startsWith('https://angle-useast1-')==false) { //if user is logged in
      const cloned = req.clone({
        //https://stackoverflow.com/questions/48683476/how-to-add-multiple-headers-in-angular-5-httpinterceptor
        headers: req.headers.set('Authorization', userData.id_token).set('Content-Type', 'application/json')
      });
      console.log('AuthIntercepterService cloned',cloned);
      return next.handle(cloned).pipe(
        retry(1),
        catchError(this.handleError)
      )
    } else { //if user is not logged in e.g. login in OR IF PRESINGED URL FROM S3
      const cloned = req.clone({
        params: req.params.set('auth', 'false'),
        headers: req.headers.set('Content-Type', 'application/json')
      });

      return next.handle(req).pipe(
        retry(1),
        catchError(this.handleError)
      );
    }
  }


} // End class
